var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "toggled",
      class: _vm.is_sidebar_minimized
        ? "toggled-expand-true"
        : "toggled-expand-false",
      attrs: { id: "wrapper" }
    },
    [
      _c("j-headful", { attrs: { title: _vm.$route.meta.title } }),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade-slow" } },
        [_vm.showPreload ? _c("j-preload") : _vm._e()],
        1
      ),
      _vm._v(" "),
      _vm.showContent ? _c("j-header") : _vm._e(),
      _vm._v(" "),
      _c("j-navbar"),
      _vm._v(" "),
      _vm.showContent
        ? _c("j-dual-sidebar-setting", {
            attrs: {
              logo: _vm.logo,
              "is-sidebar-open": _vm.sidebar,
              "products-items": _vm.productsDetails,
              "group-products": _vm.clonedGroupApps,
              "responsive-logo": _vm.responsiveLogo,
              "menus-ui": _vm.menusUiSetting,
              "menus-database": _vm.menusDatabaseSetting,
              "menus-logic": _vm.menusLogicSetting,
              "menus-other": _vm.menusOtherSetting
            },
            on: { "toggle-sidebar": _vm.toggleSidebar }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sidebar && _vm.showContent
        ? _c("div", {
            staticClass: "background-blur show",
            on: {
              click: function($event) {
                _vm.sidebar = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showContent
        ? _c("div", { staticClass: "display-block h-100" }, [
            _c(
              "div",
              { staticClass: "p__t--52 h-100" },
              [
                _c(
                  "transition",
                  { attrs: { name: "fadeout" } },
                  [_c("router-view")],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showContent
        ? _c("j-loading-screen", {
            ref: "loadingScreen",
            attrs: { message: _vm.loading_message }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showContent
        ? _c("j-info-screen", {
            ref: "infoScreen",
            attrs: { message: _vm.info_message }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showContent
        ? _c("j-problem-screen", {
            ref: "problemScreen",
            attrs: { message: _vm.problem_message, code: _vm.problem_code }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showContent
        ? _c("j-success-screen", {
            ref: "successScreen",
            attrs: { message: _vm.success_message }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("j-toast", { ref: "toastScreen" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b0e3ab44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0e3ab44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/jSettingWrapper.vue
// module id = null
// module chunks = 